import { VuiPrompt } from "../../../lib";

export const Prompt = () => <VuiPrompt onClick={() => alert("Clicked prompt")}>Who let the dogs out?</VuiPrompt>;
